<template>
			<section id="header" class="navbar-fixed-top">
	
					<nav class="navbar navbar-default navbar-fixed-top">
															
					  <div class="container">
					    <div class="navbar-header">
					      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					        <span class="sr-only">Toggle navigation</span>
					        <span class="icon-bar"></span>
					        <span class="icon-bar"></span>
					        <span class="icon-bar"></span>
					      </button>					      
						  <router-link to="/" class="navbar-brand"><img src="/static/images/iba-logo-white.png" class="img-responsive"></router-link>
					    </div>
					
					    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
					      <ul class="nav navbar-nav navbar-right" id="main-nav">
						  	<ul id="nav">
								<!-- <li>
									<router-link to="/overview">Overview</router-link>
								</li> -->
								<!-- <li>
									<router-link to="/features">Features</router-link>
								</li> -->
								<!-- <li>
									<router-link to="/benefits">Benefits</router-link>
								</li> -->
								<li>
									<router-link to="/">Home</router-link>
								</li>
								<!-- <li>
									<router-link to="/pricing">Pricing</router-link>
								</li> -->

								<li>
									<router-link to="/about">About Us</router-link>
								</li>
								<li>
									<router-link :to="'/blog/'+post">Blog</router-link>
								</li>
								<li>
									<a href="https://iba-cloud.infinittna.com">Login</a>
								</li>
								<!-- <li>
									<router-link to="/support">Support</router-link>
								</li>							 -->
								<li>
									<router-link to="/free-demo">Free Demo</router-link>
								</li>
							</ul>					      
						  </ul>
					    </div><!-- /.navbar-collapse -->
					  </div><!-- /.container-fluid -->
					</nav>

			</section>	  
</template>

<style>
#header{
  z-index:2 !important;
}
.navbar-fixed-top{
  z-index:1000 !important;
}
</style>

<script>
  import {EventBus} from '../event-bus.js'
	import posts from './blogs/posts/posts.js'

    export default {
        name: 'navbar',
        data () {
            return {
				title: "IBA",
				post: posts.length,
            }
        },
        props:['user'],
        mounted(){

        },
        methods:{
			

        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/Navbar.vue